import { ValidationError } from './errors';

export function validateSlug(slug: string): string {
  if (!slug || typeof slug !== 'string') {
    throw new ValidationError('Slug is required and must be a string', 'slug');
  }

  // Decode URL-encoded slugs (Tamil characters come encoded from browser)
  let decodedSlug = slug;
  try {
    decodedSlug = decodeURIComponent(slug);
  } catch {
    // If decoding fails, use original slug
    decodedSlug = slug;
  }

  // Allow longer slugs for Tamil/Unicode text (up to 2000 chars after decoding)
  if (decodedSlug.length > 2000) {
    throw new ValidationError('Slug is too long', 'slug');
  }

  return decodedSlug.trim();
}

export function validateStoryId(storyId: string): string {
  if (!storyId || typeof storyId !== 'string') {
    throw new ValidationError('Story ID is required and must be a string', 'storyId');
  }
  
  return storyId.trim();
}

export function isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

export function sanitizeText(text: string): string {
  if (!text || typeof text !== 'string') {
    return '';
  }
  
  return text
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<[^>]*>/g, '')
    .trim();
}
